import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { JwtHelper } from 'angular2-jwt';

import { AuthInterceptor } from '../../core/auth-interceptor';
import { AuthenticationApiService } from './services/authentication/authentication.api.service';
import { AuthenticationDomainService } from './services/authentication/authentication.domain.service';
import { DistributionApiService } from './services/distribution/distribution.api.service';
import { DistributionDomainService } from './services/distribution/distribution.domain.service';
import { SectorApiService } from './services/sector/sector.api.service';
import { SectorDomainService } from './services/sector/sector.domain.service';
import { LocalStorageService } from './services/local-storage/local-storage.service';
import { LogService } from './services/logging/log.service';

@NgModule({
    imports: [
        HttpClientModule,
        CommonModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        JwtHelper,
        LocalStorageService,
        AuthenticationApiService,
        DistributionApiService,
        DistributionDomainService,
        SectorApiService,
        SectorDomainService,
        LogService,
        AuthenticationDomainService
    ],
    declarations: [],
    exports: []
})
export class DomainModule { }



// WEBPACK FOOTER //
// ./src/app/modules/domain/domain.module.ts